import React from 'react'
import { PREP_CARDS, PREP_CORE_IDS } from './prepCardDefinitions.js'

const PREP_CORE_SET = new Set(PREP_CORE_IDS)

export function PrepCardTray({ layout, onAddCard }) {
  const available = PREP_CARDS.filter((c) => !c.hidden && !layout.includes(c.id))
  if (available.length === 0) return null

  return (
    <div style={styles.tray} data-testid="prep-card-tray">
      <div style={styles.header}>+ Add to preparation</div>
      <div style={styles.items}>
        {available.map((card) => (
          <button
            key={card.id}
            style={styles.item}
            onClick={() => onAddCard(card.id)}
            aria-label={`Add ${card.label}`}
          >
            {card.label}
            {PREP_CORE_SET.has(card.id) && <span style={styles.recommended} title="Recommended">●</span>}
          </button>
        ))}
      </div>
    </div>
  )
}

const styles = {
  tray: {
    border: '1px dashed var(--border)',
    borderRadius: '8px',
    padding: '12px 16px',
  },
  header: {
    fontSize: '11px',
    fontWeight: 600,
    color: 'var(--text-secondary)',
    marginBottom: '10px',
    letterSpacing: '-0.01em',
  },
  items: { display: 'flex', flexWrap: 'wrap', gap: '6px' },
  item: {
    display: 'flex', alignItems: 'center', gap: '4px',
    padding: '4px 10px', borderRadius: '12px',
    border: '1px solid var(--border)', background: 'transparent',
    fontSize: '11px', color: 'var(--text-secondary)',
    cursor: 'pointer', transition: 'background var(--duration-fast) ease',
  },
  recommended: { fontSize: '7px', color: '#3b82c4', lineHeight: 1 },
}
